import styled, { createGlobalStyle } from 'styled-components';
import { SYS_BORDER_RADIUS_SM, SYS_BREAKPOINT_XS, SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_700, SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_LG, SYS_SPACE_RELATIVE_SM, SYS_SPACE_RELATIVE_XS, } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper, GetSafeColorDesignToken } from '../../../../utils/AlphaHelper';
import { Card, Text } from '@oneaudi/unified-web-components';
import { SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK } from '@oneaudi/unified-web-alpha-common';
export const ModalHeader = styled.div `
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_700, SYS_SPACE_RELATIVE_2_XL)};
  @media (max-width: ${SYS_BREAKPOINT_XS}) {
    margin-top: 32px;
  }
`;
export const DialogStylingOverride = createGlobalStyle `
  ${dynamicStylingHelper(`  & div[id="layer-content"] > div {
  padding-inline: 0px;
  }`, '')};

`;
export const PriceRow = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const DisclaimerCard = styled(Card) `
  border-radius: ${SYS_BORDER_RADIUS_SM};
  backdrop-filter: none;
`;
export const PriceGroupItemsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_100, SYS_SPACE_RELATIVE_XS)};
`;
export const PriceRowLabel = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const PriceRowValue = styled.div `
  white-space: nowrap;
  margin-left: ${SYS_SPACE_FIXED_200};
`;
export const PopoverPriceDisclaimer = styled.div `
  margin-top: ${dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_LG)};
  padding: ${dynamicStylingHelper(SYS_SPACE_FIXED_200, '')};
  box-shadow: ${GetSafeColorDesignToken('shadow-l1')};
`;
export const PriceGroupStyles = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_200};
  padding-bottom: ${SYS_SPACE_FIXED_200};
  border-bottom: ${({ isLastItem, isSecondLastItem }) => isLastItem
    ? 'none'
    : isSecondLastItem
        ? `2px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`
        : `1px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`};
`;
export const PriceLabelWhite = styled(Text) `
  color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};
`;
export const PriceGroupHeadline = styled(Text) `
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_SM)};
  ${dynamicStylingHelper('', `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};`)};
`;
